import React, { useEffect, useRef } from "react";
import styles from "./Modals.module.css";
import Close from "Utils/Assets/SVGs/Close";
import ReplyToInquiryForm from "../Forms/ReplyToInquiryForm";
import { IReplyToInquiryModalProps } from "@model/contactus.model";

const ReplyToInquiryModal: React.FC<IReplyToInquiryModalProps> = ({
    contactId,
    open,
    onClose,
    originalMessage,
    title,
    onReplySuccess,
}) => {
    const dialogRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        if (open) {
            setTimeout(() => dialogRef.current?.focus(), 0);
        }
    }, [open]);

    if (!open) return null;

    return (
        <div
            className={styles.replyBackdrop}
            role="presentation"
            onMouseDown={onClose}
            data-testid="reply-inquiry-backdrop"
        >
            <div
                ref={dialogRef}
                role="dialog"
                aria-modal="true"
                aria-labelledby="reply-inquiry-title"
                tabIndex={-1}
                className={styles.replyDialog}
                onMouseDown={(e) => e.stopPropagation()}
            >
                <header className={styles.replyHeader}>
                    <h2 id="reply-inquiry-title" className={styles.replyTitle}>
                        Reply to inquiry
                    </h2>
                    <button
                        type="button"
                        className={styles.replyCloseBtn}
                        onClick={onClose}
                        aria-label="Close reply modal"
                        data-testid="reply-inquiry-close"
                    >
                        <Close width={18} height={18} />
                    </button>
                </header>

                <div className={styles.replyBody}>
                    <ReplyToInquiryForm
                        originalMessage={originalMessage}
                        title={title}
                        onClose={onClose}
                        contactId={contactId}
                        onReplySuccess={onReplySuccess}
                    />
                </div>
            </div>
        </div>
    );
};

export default ReplyToInquiryModal;
